<div class="destinations-page-container">
    <div class="destinations-page-container-block" [style]="tab ? 'position: sticky; top: 0; z-index-0' : ''">
      <app-main-destinations
        [fullRadius]="true"
        [mode]="'Continents'"
        (ClickOnActive)="goToDestination($event)"
        (emitContinent)="setFilter($event)"
        (loadingEmit)="loadCircle($event)"
      />
    </div>
    <app-destinations-countries [filter]="filter" [border]="border" (firstLoading)="loadingEmit($event)" style="z-index: 5"/>
</div>
